module.exports = __webpack_public_path__ + "img/category-skill-game.8bfc95aa.png";